import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router";
import { Form, Formik } from "formik";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { FcViewDetails } from "react-icons/fc";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import Footer from "../../../Components/Footer/footer";
import { SiScheduleByClient } from "../../../SchemaInfo/info";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import LoadingPage from "../../../Components/layouts/loading";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SimpleButton from "../../../Components/layouts/simple_button";

function EditSiSchedules() {
  const { id } = useParams();
  const [count, setCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [extendDate, setExtendDate] = useState("")

  const [userSelectedSlots, setUserSelectedSlots] = useState([]); 
  const [fullyBookedDates, setFullyBookedDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [availableSlotsForSelectedDates, setAvailableSlotsForSelectedDates] =
    useState([]);
  const [orderData, setOrderData] = useState({}) ;
  const navigate = useNavigate()
 

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0].split("-").reverse().join("-");
  };
  const getNext7Days = (startDateStr) => {
    // Convert "27-03-2025" to "2025-03-27" (YYYY-MM-DD) for Date object
    const [day, month, year] = startDateStr.split("-");
    const startDate = new Date(`${year}-${month}-${day}`);
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(startDate);
      date.setDate(date.getDate() + i);
      const formattedDate = date
        .toISOString()
        .split("T")[0]
        .split("-")
        .reverse()
        .join("-"); // Convert back to DD-MM-YYYY
      dates.push(formattedDate);
    }
    
    return dates;
  };
  



  const handelSubmitPatch = (values) => {
    let data = {userSelectedSlots, values, orderData}
    setLoading(true);
    performRequest(
      "PATCH",
      `/bookSiteInspection/editClientSchedule/`,
      data, 
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Date Selected Successfully");
          navigate("/si-schedules")
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  

  };

  useEffect(() => {
 if(id){
    performRequest("GET", `/bookSiteInspection/getOrderIdDetails/${id}`)
    .then((res) => {
      if (res.status === 200) {
        setOrderData(res.data)
      }
    })
    .catch((err) => {
      CustomErrorResponse(err);
    });
 }
  }, []);

  useEffect(() => {
    performRequest("GET", `/bookSiteInspection/getFullyBookedDates/`)
      .then((res) => {
        if (res.status === 200) {
          setFullyBookedDates(res.data.fullyBookedDates);
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }, []);

  useEffect(() => {
    performRequest("GET", `/bookSiteInspection/getOrderIdCount/${id}`)
      .then((res) => {
        if (res.status === 200) {
          
          let date = formatDate(res.data?.verifyOrderId.createdAt)
          if(date){
          
            setExtendDate(date)
          }
        }
      })
      .catch((err) => {
        Toast("error", err);
      });
  }, []);



  const isDateDisabled = (date) => {
    // Convert extendDate (string) to Date object
  
    const [dayE, monthE, yearE] = extendDate.split("-");
    const extendDateObj = new Date(`${yearE}-${monthE}-${dayE}`);
   
    // Get the next 7 days (including extendDate)
    const next7Days = getNext7Days(extendDate);
  
    // Format given date to "DD-MM-YYYY"
    const formattedDate = date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
  
    // Disable if:
    return (
      date < extendDateObj || // All previous dates
      next7Days.includes(formattedDate) || // Next 7 days including extendDate
      date.getDay() === 0 || date.getDay() === 6 || // Disable weekends (Sunday & Saturday)
      fullyBookedDates.includes(formattedDate) // Fully booked dates
    );
  };
  const handleSlotSelect = (slot) => {
    setUserSelectedSlots([slot]); 
  };

  useEffect(() => {
    if (selectedDate) {
      performRequest(
        "GET",
        `/bookSiteInspection/getSiteInspectionScheduelsByDate/${selectedDate}`
      )
        .then((res) => {
          if (res.status === 200) {
            setAvailableSlotsForSelectedDates(res.data.availableSlots);
          }
        })
        .catch((err) => {
          CustomErrorResponse(err);
        });
    } else {
      setAvailableSlotsForSelectedDates([]);
    }
  }, [selectedDate]);

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    <FcViewDetails className="fs-2 me-1" />
                    Edit Site Inspection
                  </h2>
                  <h4 className="text-muted">
                    Edit Site Inspection Schedules Dates .
                  </h4>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="card-header">
                <h2 className="page-title">Edit Site Inspection Details</h2>
              </div>
              {(count === 3 || count>3) ? (
                <p className="text-center m-1">
                  {" "}
                  You Have Already Selected the dates
                </p>
              ) : (
                <Formik
                  initialValues={SiScheduleByClient}
                //   validationSchema={SiScheduledSchema}
                  onSubmit={handelSubmitPatch}
                >
                  {(props) => (
                    <Form>
                    
                      <div className="card-body">
                        <div className="row">
                          <div className="col-12">

                            {/* Select Dates */}
                            <div className="mb-3">
                              <label className="form-label  col-3">
                                Select Date 
                              </label>
                            
                              <DatePicker
                                selected={
                                  props.values.date1
                                    ? new Date(
                                        props.values.date1
                                          .split("-")
                                          .reverse()
                                          .join("-")
                                      )
                                    : null
                                }
                                onChange={(date) => {
                                  if (date) {
                                    const formattedDate = date
                                      .toLocaleDateString("en-GB", {
                                        day: "2-digit",
                                        month: "2-digit",
                                        year: "numeric",
                                      })
                                      .replace(/\//g, "-");
                                    props.setFieldValue("date1", formattedDate);
                                    setSelectedDate(formattedDate);
                                  }
                                }}
                                filterDate={(date) => {
                                  return !isDateDisabled(date);
                                }}
                                minDate={new Date()} // Disable past dates
                                className="form-control w-100"
                                wrapperClassName="w-100"
                                placeholderText="DD-MM-YYYY"
                                dateFormat="dd-MM-yyyy"
                                
                              />

                              {props.touched.date1 && props.errors.date1 && (
                                <p className="text-danger">
                                  {props.errors.date1}
                                </p>
                              )}
                            </div>

                            <div className="card">
                              <div className="card-header">
                                <div className="col-4 form-label"> Select Slot</div>{" "}
                              </div>
                              <div className="card-body">
                                <div className="row">
                                  {!props.values.date1 ? (
                                    <p> Please Select Date </p>
                                  ) : availableSlotsForSelectedDates?.length >
                                    0 ? (
                                    availableSlotsForSelectedDates?.map(
                                      (slot) => (
                                        <div key={slot.id || slot} className="col-md-3">
                                          <div
                                            className={`card my-1 ${
                                                userSelectedSlots.length > 0 && userSelectedSlots[0] === slot
                                                ? "bg-green text-white"
                                                : ""
                                            }`}
                                            onClick={() =>
                                              handleSlotSelect(
                                                slot,
                                                props.values.date1
                                              )
                                            }
                                            style={{
                                              cursor: "pointer",
                                              opacity:   userSelectedSlots.length > 0 && userSelectedSlots[0]?.id === slot
                                                ? 0.5
                                                : 1,
                                            }}
                                          >
                                            <div className="card-body">
                                              <p className="card-text">
                                                {slot}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <p>
                                      All Slots are booked, Choose Another Date
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Submit" />
                        
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              )}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}

export default EditSiSchedules;
